export default {"src":"/_next/static/media/hiking.4fac05a1.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};